import { useMutation } from '@tanstack/react-query';
import { coreApi } from '../../../../utils/axios';

export type UpdateInactiveOrderingPayload = {
  inactive_ordering: boolean | null;
};

type UpdateInactiveOrderingResponse = {
  success: boolean;
  pharmacy_id: string;
  inactive_ordering: boolean | null;
};

const updateInactiveOrdering = (pharmacyId: string, payload: UpdateInactiveOrderingPayload) => {
  return coreApi.put<UpdateInactiveOrderingResponse>(`/pharmacies/${pharmacyId}/inactive-ordering`, payload);
};

export function useUpdateInactiveOrdering(pharmacyId: string) {
  return useMutation({
    mutationFn: async (payload: UpdateInactiveOrderingPayload) => {
      const response = await updateInactiveOrdering(pharmacyId, payload);
      return response.data;
    },
  });
}

export function getMissingRequirements(error: any): string[] {
  return error?.response?.data?.data?.missing_requirements || [];
}
